module.exports = __webpack_public_path__ + "static/img/HK-and-MO-pass-back.97d92d70.png";